import { useRoute } from 'vue-router'
import OverviewTypes from '@/config/OverviewTypes'
import { computed } from 'vue'

export default () => {
  const route = useRoute()

  return {
    overviewType: computed(() => {
      if (!route.name) return null

      if (route.name.includes('marketplace-search')) {
        return OverviewTypes.Search
      }

      if (route.name.endsWith('slug')) {
        return OverviewTypes.City
      }

      return OverviewTypes.Marketplace
    }),
  }
}
